/** @jsx jsx */
import { useRef, useState, Fragment } from 'react';
import { Grid, Box, Flex, Container, Heading, Button, jsx } from 'theme-ui';
import { IoIosMenu, IoIosSearch, IoIosClose } from 'react-icons/io';
import { AiOutlineUser } from 'react-icons/ai';
import Drawer from 'rc-drawer';
import 'rc-drawer/assets/index.css';
import Logo from '../../ui-elements/logo/logo';
import Search from '../../search';
import useOnClickOutside from '../../../hooks/useOutsideClick';
import MainMenu from '../navbar/main-menu';
import Footer from '../../footer/footer';
import styles from './topbar.style';
// logo img
import logoImg from '../../../images/logo.svg';

const Topbar: React.FC<{}> = () => {
	const [visible, setVisible] = useState(false);
	const [mobileSearchToggle, setMobileSearchToggle] = useState(false);
	const mobileSearchRef = useRef(null!);
	useOnClickOutside(mobileSearchRef, () => setMobileSearchToggle(false));

	return (
		<Fragment>
			<Box sx={styles.topbarStatus}>Free Home Delivery!</Box>
			<Box
				className={mobileSearchToggle ? 'mobileSearch' : ''}
				sx={styles.topbar}
			>
				<Container>
					{mobileSearchToggle ? (
						<Box ref={mobileSearchRef}>
							<Search />
						</Box>
					) : (
						<Grid sx={styles.grid}>
							<Flex>
								<Button
									sx={styles.hamburgBtn}
									variant="text"
									onClick={() => setVisible(true)}
								>
									<IoIosMenu />
								</Button>

								<Logo imgSrc={logoImg} />
							</Flex>

							<Box>
								<Button
									sx={styles.searchBtn}
									variant="text"
									onClick={() => setMobileSearchToggle(true)}
								>
									<IoIosSearch />
								</Button>

								<Search />
							</Box>

							<Box sx={styles.rightPart}>
								<a
									href="https://picksystore.myshopify.com/account"
									target="_blank"
								>
									<AiOutlineUser />
								</a>
							</Box>
						</Grid>
					)}
				</Container>

				{/* Side drawer for mobile menu */}
				{visible && (
					<Drawer
						level={null}
						width="100%"
						open={visible}
						handler={false}
						placement="left"
						onClose={() => setVisible(false)}
					>
						<Flex sx={styles.drawerTitle}>
							<Heading as="h2">Categories</Heading>
							<Button variant="text" onClick={() => setVisible(false)}>
								<IoIosClose />
							</Button>
						</Flex>
						<MainMenu onClick={() => setVisible(false)} />
						<Footer />
					</Drawer>
				)}
				{/* End of side drawer for mobile menu */}
			</Box>
		</Fragment>
	);
};

export default Topbar;
